<template>
  <div class="lobby">
    <template v-if="this.$route.name === 'game'">
      <div class="lobby__game-frame-wrapper">
        <a class="lobby__game-frame-anchor"
          @click="goToLobby()">&laquo; {{$t('game.go-back')}}
        </a>
        <div class="lobby__game-frame" >
          <iframe :src="gameUrl" />
        </div>
      </div>
    </template>
    <template v-else-if="this.$route.name === 'article'">
      <div class="lobby__article">
        <a class="lobby__game-frame-anchor"
          @click="goToLobby()">
          &laquo; {{$t('game.go-back')}}
        </a>
        <div
          v-html="$t(article)">
        </div>
      </div>
    </template>
    <template v-else>
      <div class="lobby__banner" :class="`lobby__banner--${this.$root.$i18n.locale}`">
        <img :src="getBannerImgUrl()" />
        <div class="lobby__banner-content">
          <template v-if="this.$route.name !== 'home-money'">
            <h1 class="lobby__banner-title">
              <span>
                {{$t(titleTag1)}}
              </span>
              <br />
              <span>
                {{$t(titleTag2)}}
              </span>
            </h1>
            <dl>
              <dt>
                <span class="lobby__list-icon mdi mdi-check"></span>
              </dt>
              <dd>{{$t(bannerFakePoint1)}}</dd>
              <dt>
                <span class="lobby__list-icon mdi mdi-check"></span>
              </dt>
              <dd>{{$t(bannerFakePoint2)}}</dd>
              <dt>
                <span class="lobby__list-icon mdi mdi-check"></span>
              </dt>
              <dd>{{$t(bannerFakePoint3)}}</dd>
            </dl>
          </template>
          <template v-else>
            <h1 class="lobby__banner-title">
              <span>
                {{$t(moneyTitleTag1)}}
              </span>
              <br />
              <span>
                {{$t(moneyTitleTag2)}}
              </span>
            </h1>
            <dl>
              <dt>
                <span class="lobby__list-icon mdi mdi-check"></span>
              </dt>
              <dd>{{$t('banner.point-1')}}</dd>
              <dt>
                <span class="lobby__list-icon mdi mdi-check"></span>
              </dt>
              <dd>{{$t('banner.point-2')}}</dd>
              <dt>
                <span class="lobby__list-icon mdi mdi-check"></span>
              </dt>
              <dd>{{$t(bannerPoint3)}}</dd>
            </dl>
          </template>
          <div class="lobby__cta">
            <template
              v-if="this.$route.name === 'home-money'">
              <a class="button"
                @click="goToMoneySite()">
                {{$t('banner.cta')}}
              </a>
            </template>
            <template v-else>
              <a class="button" v-scroll-to="'#lobbyGames'">
                <template v-if="this.$route.query.site">
                  {{$t(`banner.cta-${this.$route.query.site}`)}}
                </template>
                <template v-else>
                  {{$t(`banner.cta`)}}
                </template>
              </a>
            </template>
          </div>
        </div>
      </div>
      <div class="lobby__games" id="lobbyGames">
        <template v-for="(item, index) in getGames()">
          <template v-if="(index + 1) <= lobbyLimit">
            <div
              :key="`game-item-${index}`"
              class="lobby__game-item"
              v-if="item.thumbnailImg" @click="goToGame(item)">
              <img :src="item.thumbnailImg" :alt="item.name" />
              <div class="lobby__game-item-details">
                <div class="content">
                  <span class="content-name">{{item.name}}</span>
                  <i class="icon mdi mdi-play-circle"></i>
                </div>
              </div>
            </div>
          </template>
        </template>
      </div>
      <div class="lobby__load-more lobby__cta">
        <a class="button" @click="loadMore">{{$t('general.load-more')}}</a>
      </div>
    </template>
  </div>
</template>

<script>
import { games } from '../../config/games'
import performingGames from '../../config/performing-games'
import customGames from '../../config/custom-games'
import skippedGames from '../../config/skipped-games'
import { isMobile } from 'mobile-device-detect'

export default {
  name: 'Lobby',
  data () {
    return {
      limit: 20,
      customGames
    }
  },
  computed: {
    article () {
      if (this.$route.query.site) {
        return `${this.$route.params.article}.article-${this.$route.query.site}`
      } else {
        return `${this.$route.params.article}.article`
      }
    },
    lobbyLimit () {
      return this.limit
    },

    titleTag1 () {
      if (this.$route.query.h) {
        return `banner.${this.$route.query.h}-title-1`
      } else {
        return `banner.title-1`
      }
    },

    titleTag2 () {
      if (this.$route.query.h) {
        return `banner.${this.$route.query.h}-title-2`
      } else {
        return `banner.title-2`
      }
    },

    moneyTitleTag1 () {
      if (this.$route.query.h) {
        return `banner.${this.$route.query.h}-money-title-1`
      } else {
        return `banner.money-title-1`
      }
    },

    moneyTitleTag2 () {
      if (this.$route.query.h) {
        return `banner.${this.$route.query.h}-money-title-2`
      } else {
        return `banner.money-title-2`
      }
    },

    bannerPoint3 () {
      if (this.$route.query.aff) {
        return `banner.point-3-${this.$route.query.aff}`
      } else {
        return `banner.point-3`
      }
    },

    bannerFakePoint1 () {
      if (this.$route.query.site) {
        return `banner.fake-point-1-${this.$route.query.site}`
      } else {
        return `banner.fake-point-1`
      }
    },

    bannerFakePoint2 () {
      if (this.$route.query.site) {
        return `banner.fake-point-2-${this.$route.query.site}`
      } else {
        return `banner.fake-point-2`
      }
    },

    bannerFakePoint3 () {
      if (this.$route.query.site) {
        return `banner.fake-point-3-${this.$route.query.site}`
      } else {
        return `banner.fake-point-3`
      }
    },

    games () {
      if (this.$route.name === 'home-money') {
        let g = games.filter(g =>
          (g.device === 'all' || (isMobile ? g.device === 'mobile' : g.device === 'desktop')) &&
          (performingGames.indexOf(g.slug) === -1))
        const shuffled = g.sort(() => 0.5 - Math.random())
        return shuffled
      } else {
        let g = games.filter(g =>
          (g.device === 'all' || (isMobile ? g.device === 'mobile' : g.device === 'desktop')) &&
          (skippedGames.indexOf(g.slug) === -1) &&
          (g.provider === 'Quickspin'))
        const shuffled = g.sort(() => 0.5 - Math.random())
        return shuffled
      }
    },

    game () {
      if (this.$route.name === 'game' && this.$route.params.name) {
        return games.find(g => g.slug === this.$route.params.name)
      }
      return {}
    },

    gameUrl () {
      if (this.game) {
        let locale = 'en'
        if (this.$root.$i18n.locale === 'de') {
          locale = 'de'
        }
        return `https://play.togethergaming.com/wetten/${this.game.key}?language=${locale}&homeurl=https://wetten.com/`
      }
      return ''
    }
  },
  methods: {
    getGames () {
      let locale = this.$root.$i18n.locale
      if (this.$route.name === 'home-money') {
        if (this.customGames[locale]) {
          return this.customGames[locale]
        }
      }
      return this.games
    },

    loadMore () {
      if (this.$route.name === 'home-money') {
        this.goToMoneySite()
      } else {
        this.limit += 20
      }
    },

    getBannerImgUrl () {
      let locale = this.$root.$i18n.locale
      let url = ''
      if (this.$route.name === 'home-money') {
        url = `/images/lp-header-${locale}-1.jpg`
        if (this.$route.query.aff) {
          url = `/images/lp-header-${locale}-1-${this.$route.query.aff}.jpg`
        }
      } else {
        if (this.$route.query.site) {
          url = `/images/lp-header-${locale}-0-${this.$route.query.site}.jpg`
        } else {
          url = `/images/lp-header-${locale}-0.jpg`
        }
      }
      return url
    },

    getBannerImg () {
      let locale = this.$root.$i18n.locale
      let url = ''
      if (this.$route.name === 'home-money') {
        url = `/images/lp-header-${locale}-1.jpg`
        if (this.$route.query.aff) {
          url = `/images/lp-header-${locale}-1-${this.$route.query.aff}.jpg`
        }
      } else {
        url = `/images/lp-header-${locale}-0.jpg`
      }
      return {
        'background': `url('${url}') center center / cover`
      }
    },

    goToLobby () {
      this.$router.push({
        query: { ...this.$route.query },
        name: 'home'
      })
    },

    goToMoneySite () {
      let gclid = this.$route.query.gclid || ''
      let siteId = this.$route.query.siteId || ''
      let btag = this.$route.query.btag || ''
      let adId = this.$route.query.adId || '185'
      let aff = this.$route.query.aff
      let redirectUrl = ''
      if (aff) {
        let affLink = this.$t(`general.affiliate-link-${aff}`)
        redirectUrl = `${affLink}&c=${gclid}`
      } else {
        redirectUrl = `https://wlwetten.adsrv.eacdn.com/C.ashx?btag=${btag}&affid=453&siteid=${siteId}&adid=${adId}&c=${gclid}`
      }
      window.open(
        redirectUrl,
        `_blank`
      )
    },

    goToGame (item) {
      if (this.$route.name !== 'home-money') {
        this.$router.push({ name: 'game',
          query: { ...this.$route.query },
          params: {
            lang: this.$i18n.locale,
            category: item.categories[0].categoryId,
            name: item.slug
          }
        })
      } else {
        this.goToMoneySite()
      }
    }
  }
}
</script>

<style lang="stylus">
.lobby
  width 90%
  margin 0 auto
  max-width 1024px
  min-height calc(100vh - 140px)
  &__article
    background #fff
    padding 20px
    text-align left
    .lobby__game-frame-anchor
      color #000 !important
    a
      color #000
      &:hover
        text-decoration none
    p
      line-height 21px
    h1,h2
      cursor default
      &:first-of-type
        margin-top 0
  &__cta
    margin-bottom 10px
    .button
      display inline-block
      padding 12px 20px
      font-size 20px
      color #fff
      background-color #46c977
      border 0
      cursor pointer
      font-weight 700
      border-radius 5px
  &__banner
    margin-bottom 10px
    position relative
  &__banner--ja
    min-height 400px
  &__banner-content
    width 40%
    text-align left
    color #fff
    position absolute
    top 20px
    dl
      margin 0
      margin-bottom 20px
      font-size 14px
    dd
      margin-inline-start 28px
      margin-top -20px
  &__banner-subtitle
    font-size 14px
    cursor default
    line-height 21px
    margin 0 0 10px 0
  &__banner-title span
    border-bottom 5px solid #fcdb00
    padding 2px 5px
    background #fff
    margin-bottom 5px
    display inline-block
  &__banner-title
    font-size 28px
    margin 0 0 10px 0
    color #000
    letter-spacing -1px
    font-weight bold
    cursor default
  &__banner img
    width 100%
    height auto
    display block
  &__games
    display flex
    flex-flow wrap
    justify-content flex-start
  &__game-item
    width 25%
    position relative
    cursor pointer
    &:hover
      & ^[0]__game-item-details
        display flex
  &__game-item img
    width 100%
    display block
  &__game-item-details
    display none
    color #fff
    width 100%
    height 100%
    top 0
    background #000000cc
    position absolute
    justify-content center
    align-items center
    .content
      width 80%
      text-align center
      display flex
      flex-direction column
    .content-name
      font-weight bold
      margin-bottom 10px
    .icon
      font-size 80px
  &__game-frame-wrapper
    padding-top 20px
  &__game-frame iframe
    height 640px
    width 100%
    border 0px
  &__list-icon
    color #46c977
    font-weight 800
    font-size 20px
    margin-right 5px
  &__game-frame-anchor
    margin-bottom 20px
    text-decoration underline
    cursor pointer
    display block
    color #fff !important
    &:hover
      text-decoration none
  &__load-more
    margin-top 20px
    .button
      font-size 14px
      background #3c3c44
      &:hover
        background #4e4e4e

@media (max-width: 1075px)
  .lobby
    &__banner-title
      font-size 26px
      line-height 26px

@media (max-width: 994px)
  .lobby
    &__banner-title
      font-size 20px
      line-height 20px

@media (max-width: 860px)
  .lobby
    &__game-item
      width 33%

@media (max-width: 980px)
  .lobby
    &__banner
      min-height 380px

@media (max-width: 640px)
  .lobby
    &__banner-content
      width 100%
      left 10px
      margin-top 90px
      dl
        font-size 12px

@media (max-width: 370px)
  .lobby
    &__banner
      min-height 400px

@media (max-width: 580px)
  .lobby
    &__game-item
      width 50%

</style>
